module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vpelv4-3f37f346fb9381746a3cf5fad32de482.jpg";